import { render, staticRenderFns } from "./Leagues.vue?vue&type=template&id=90293346&scoped=true&"
import script from "./Leagues.vue?vue&type=script&lang=js&"
export * from "./Leagues.vue?vue&type=script&lang=js&"
import style0 from "./Leagues.vue?vue&type=style&index=0&id=90293346&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90293346",
  null
  
)

export default component.exports